import React from 'react';
import cn from 'classnames';

import {IEmarsysZoneProps} from './IEmarsysZone';

const EmarsysZone = ({id} : IEmarsysZoneProps) => {
	return (
		<div id={`emarsys-zone-${id}`} className={cn('emarsys-zone')} />
	);
};

export default EmarsysZone;
